<template>
    <div data-spec-class="availability-hint">
        <hint-highlight v-if="device.available_from">
            {{ $t('configuratorDedicated.availableFrom', { date: $d(device.available_from) }) }}
        </hint-highlight>
        <hint v-else>
            {{ $t('configuratorDedicated.provision') }}
        </hint>
    </div>
</template>

<script setup>
import Hint from './Configurator/Hint.vue';
import HintHighlight from './Configurator/HintHighlight.vue';

defineProps({
    device: {
        type: Object,
        default: null,
    },
});
</script>
